// source: miraibaraiops/operator.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var miraibaraiops_ops_common_pb = require('../miraibaraiops/ops_common_pb.js');
goog.object.extend(proto, miraibaraiops_ops_common_pb);
var scalapb_scalapb_pb = require('../scalapb/scalapb_pb.js');
goog.object.extend(proto, scalapb_scalapb_pb);
goog.exportSymbol('proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.displayName = 'proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.toObject = function(opt_includeInstance) {
  return proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.toObject = function(includeInstance, msg) {
  var f, obj = {
ipRangeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
role: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment;
  return proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIpRangeId(value);
      break;
    case 2:
      var value = /** @type {!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole} */ (reader.readEnum());
      msg.setRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIpRangeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string ip_range_id = 1;
 * @return {string}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.getIpRangeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.setIpRangeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional OperationRole role = 2;
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole}
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.getRole = function() {
  return /** @type {!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.kipp.miraibarai.grpc.ops.v1.OperationRole} value
 * @return {!proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment} returns this
 */
proto.com.kipp.miraibarai.grpc.ops.v1.RoleAssignment.prototype.setRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto.com.kipp.miraibarai.grpc.ops.v1);
